module.exports = __webpack_public_path__ + "static/img/icon-eva3.a8b8892.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icon-eva3.jpg
// module id = XIXL
// module chunks = 21